module.exports = ".issue-info input[type=\"text\"],\r\n.issue-info input[type=\"date\"],\r\n.issue-info select{\r\n    width:150px;\r\n    padding:0px 5px;\r\n    border:1px solid #ccc;\r\n}\r\n\r\n.forward div.float-right{\r\n    margin-right:10px;\r\n}\r\n\r\n.forward div.float-right select{\r\n    width:200px;\r\n    border:1px solid #ccc;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/issue-detailed-view/issue-detailed-view.component.css
// module id = ./src/app/issues/issue-detailed-view/issue-detailed-view.component.css
// module chunks = main